/* eslint-disable import/no-anonymous-default-export */
export default {
  translation: {
    patentstyret: 'Norwegian Industrial Property Office',
  },
};
